import { AxiosResponse } from "axios";
import { AxiosInstance } from "./axiosInstance";
import {
  ContactInfoItem,
  GetContactInfoResponse,
  GetLicenseListResponse,
  GetVersionResponse,
  OtpRequest,
  OtpResponse,
  GetTechSupportListResponse
} from "./interfaces/helpInterface.interface";
import { BasePagination } from "./interfaces/commonInterface.interface";
import qs from "qs";
import { CRUDRecorderResponse } from "./interfaces/recorderInterface.interface";
import { CUDGroupResponse } from "./interfaces/userInterface.interface";

const API_PATH = "/help";
// Get storage status
export const getLicenseList = async ({
  payload,
}: {
  payload: BasePagination;
}): Promise<GetLicenseListResponse> => {
  try {
    const { data }: AxiosResponse<GetLicenseListResponse> =
      await AxiosInstance.get(`${API_PATH}/about?${qs.stringify(payload)}`);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const postIssue = async ({
  form,
  accountId,
}: {
  form: FormData;
  accountId: string;
}): Promise<CRUDRecorderResponse> => {
  try {
    const res: AxiosResponse<CRUDRecorderResponse> = await AxiosInstance.post(
      `${API_PATH}/about/submitIssue/${accountId}`,
      form
    );
    return res.data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getVersion = async (): Promise<GetVersionResponse> => {
  try {
    const { data }: AxiosResponse<GetVersionResponse> = await AxiosInstance.get(
      `/about/version`
    );
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getContactInfo = async (
  accountId: string
): Promise<GetContactInfoResponse> => {
  try {
    const { data }: AxiosResponse<GetContactInfoResponse> =
      await AxiosInstance.get(
        `${API_PATH}/techSupport/contactInfo/view/${accountId}`
      );
    return data;
  } catch (e) {
    throw e;
  }
};
export const getInformation = async (
  accountId: string
): Promise<GetContactInfoResponse> => {
  try {
    const { data }: AxiosResponse<GetContactInfoResponse> =
      await AxiosInstance.get(
        `${API_PATH}/techSupport/contactInfo/myprofile/${accountId}`
      );
    return data;
  } catch (e) {
    throw e;
  }
};

export const updateContactInfo = async (
  accountId: string,
  payload: ContactInfoItem
): Promise<GetContactInfoResponse> => {
  try {
    const { data }: AxiosResponse<GetContactInfoResponse> =
      await AxiosInstance.put(
        `${API_PATH}/techSupport/contactInfo/update/${accountId}`,
        payload
      );
    return data;
  } catch (e) {
    throw e;
  }
};

export const postContactInfo = async (
  accountId: string,
  payload: ContactInfoItem
): Promise<GetContactInfoResponse> => {
  try {
    const { data }: AxiosResponse<GetContactInfoResponse> =
      await AxiosInstance.post(
        `${API_PATH}/techSupport/contactInfo/create/${accountId}`,
        payload
      );
    return data;
  } catch (e) {
    throw e;
  }
};

export const postGenerateOTP = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: OtpRequest;
}): Promise<OtpResponse> => {
  try {
    const { data }: AxiosResponse<OtpResponse> = await AxiosInstance.post(
      `${API_PATH}/otp/generate/${accountId}`,
      payload
    );
    return data;
  } catch (e) {
    throw e;
  }
};


export const getTechSupportList = async ({
  payload,
}: {
  payload: BasePagination;
}): Promise<GetTechSupportListResponse> => {
  try {
    const { data }: AxiosResponse<GetTechSupportListResponse> =
      await AxiosInstance.get(
        `${API_PATH}/techSupport/getAll?${qs.stringify(payload, {
          skipNulls: true,
        })}`
      );
    // console.log(data);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const createTechSupport = async ({
  accountId,
  form,
}: {
  accountId: string;
  form: FormData;
}): Promise<CUDGroupResponse> => {
  try {
    const { data }: AxiosResponse<CUDGroupResponse> = await AxiosInstance.post(
      `${API_PATH}/techSupport/submit/${accountId}`,
      form
    );
    // console.log(data);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const updateTechSupport = async ({
  id,
  payload,
}: {
  id: string;
  payload: FormData;
}): Promise<CUDGroupResponse> => {
  try {
    const { data }: AxiosResponse<CUDGroupResponse> = await AxiosInstance.put(
      `${API_PATH}/techSupport/update/${id}`,
      payload
    );
    // console.log(data);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};